/**
 * Story times as time since the earthquake (plans/00 B3, 5.7; plans/03 A3;
 * port of artifact `parts/85-nec-elapsed-times.js` ELAPSED.fmt).
 *
 * Servers send labels; the browser formats only what it computes itself
 * (slider positions, countdowns). The backend mirror is
 * `app/services/dr/elapsed.py` (`fmt_elapsed`, `fmt_duration`).
 */

/** Minutes in a day. */
const DAY_MIN = 1440

/**
 * Minute of the day at which the story clock starts (the artifact writes T0 as
 * `D0 16:10`). Only used to name calendar days ("day 3") past +48 h.
 */
const T0_MINUTE_OF_DAY = 16 * 60 + 10

/** Beyond this many minutes `fmtElapsed` names the day instead of the hours. */
const HOURS_UNTIL_MIN = 2 * DAY_MIN

function hoursAndMinutes(total: number): string {
  const h = Math.floor(total / 60)
  const m = total % 60
  if (h === 0) return `${m} min`
  return m ? `${h} h ${m} min` : `${h} h`
}

/**
 * "+0 min", "+34 min", "+1 h 10 min", "+16 h 20 min", "+24 h"; past +48 h the
 * story day ("day 3", counting the day of the earthquake as day 0).
 * Null, undefined or a negative minute (before the earthquake) give null.
 */
export function fmtElapsed(min: number | null | undefined): string | null {
  if (min === null || min === undefined || !Number.isFinite(min) || min < 0) return null
  const v = Math.round(min)
  if (v > HOURS_UNTIL_MIN) return `day ${Math.floor((v + T0_MINUTE_OF_DAY) / DAY_MIN)}`
  return `+${hoursAndMinutes(v)}`
}

/** A span for "in" and "left" phrases: "30 min", "1 h 10 min", "55 h 40 min". Negative spans read as 0 min. */
export function fmtDuration(min: number | null | undefined): string | null {
  if (min === null || min === undefined || !Number.isFinite(min)) return null
  return hoursAndMinutes(Math.max(0, Math.round(min)))
}

/** The label before the earthquake (story step `s0`, clock -1). */
export const BEFORE_EARTHQUAKE_LABEL = 'Before the earthquake'
